const ru = {
  description:
    'Продолжая использовать наш сайт, вы соглашаетесь на использование файлов cookie для поддержки вашего опыта.',
  ok: 'Принять',
  title: 'Наш сайт использует файлы cookie',
};

export default ru;
